var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import classNames from "classnames";
import SecondaryNavLayout from "../../Layout/SecondaryNavLayout";
import ContentLayout from "../../Layout/ContentLayout";
import SecondaryNavButton from "../../UI/SecondaryNav/SecondaryNavButton";
import PipelineTableView from "../../Container/Pipeline/PipelineTableView";
import PipelineCardView, { Provider, } from "../../Container/Pipeline/PipelineCardView";
import useService from "../../Hooks/useService";
import PipelineService from "../../../Services/Pipeline.service";
import { InlineFormFormat } from "../../UI/FormFormat/FormFormat";
import TextField from "../../Form/TextField";
import SearchField from "../../Form/SearchField";
import DateRangeField from "../../Form/DateRangeField";
import { StageMultiSearch } from "../../Presentational/Stage/StageSearch";
import ServiceResult, { Loaders } from "../../UI/ServiceResult/ServiceResult";
import { getPipelinesListPath, getPipelineEditRoute } from "./PipelineRoutes";
import useCheckboxes from "../../Hooks/useCheckboxes";
import TabsLayout from "../../Layout/TabsLayout";
import PipelineStatusBadge from "../../Presentational/PipelineStatus/PipelineStatusBadge";
import CustomCard from "../../UI/CustomCard/CustomCard";
import InfoItems from "../../UI/InfoItems/InfoItems";
import DateService from "../../../Services/Shared/Date.service";
import LinkToPerson from "../../Presentational/Person/LinkToPerson/LinkToPerson";
import PipelineStatusDomainService from "../../../Domain/PipelineStatus/PipelineStatus.service";
import useErrorPopup from "../../Hooks/useErrorPopup";
import { PipelineDetailAnalysis } from "../../Container/Pipeline/PipelineDetailAnalysis";
import useConfirmation from "../../Hooks/useConfirmation";
import { OpportunitySourceMultiSearch } from "../../Presentational/OpportunitySource/OpportunitySourceSearch";
import useHasPermission from "../../Hooks/useHasPermission";
import PipelineDetailListMenu from "../../Container/Pipeline/PipelineDetailListMenu";
import { OpportunityAssigneeMultiSearch } from "../../Presentational/Opportunity/OpportunityAssigneeSearch";
import { ToggleButton } from "../../UI/StandardButtons/StandardButtons";
import WidgetRefreshButton from "../../Presentational/Widgets/WidgetRefreshButton";
import BooleanDisplay from "../../UI/BooleanDisplay/BooleanDisplay";
import { AlertInfo } from "../../UI/StandardAlerts/StandardAlerts";
import PersonTypeContextProvider from "../../Hooks/usePersonType";
import PageTitle from "../../UI/PageTitle/PageTitle";
import ListService from "../../../Services/Shared/List.service";
import PopulationService from "../../../Services/Population.service";
const FilterAutomatedScheduleView = ({ pipeline, refreshPopulation, isLoading, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    let maxRefreshDate = null;
    let wasLastManuallyRefreshed = false;
    if (((_a = pipeline.automatedSchedule) === null || _a === void 0 ? void 0 : _a.lastExecutionDate) &&
        pipeline.lastManualRefresh) {
        if (pipeline.lastManualRefresh.getTime() >
            pipeline.automatedSchedule.lastExecutionDate.getTime()) {
            maxRefreshDate = pipeline.lastManualRefresh;
            wasLastManuallyRefreshed = true;
        }
        else {
            maxRefreshDate = pipeline.automatedSchedule.lastExecutionDate;
            wasLastManuallyRefreshed = false;
        }
    }
    else if ((_b = pipeline.automatedSchedule) === null || _b === void 0 ? void 0 : _b.lastExecutionDate) {
        maxRefreshDate = pipeline.automatedSchedule.lastExecutionDate;
        wasLastManuallyRefreshed = false;
    }
    else if (pipeline.lastManualRefresh) {
        maxRefreshDate = pipeline.lastManualRefresh;
        wasLastManuallyRefreshed = true;
    }
    else if (pipeline.population) {
        maxRefreshDate = pipeline.createdDate;
    }
    const [populationCaseloads, loadPopulationCaseloads] = useService(PopulationService.getCaseloadsSelectionForFilterBackedPopulation);
    React.useEffect(() => {
        var _a, _b;
        if ((_a = pipeline.population) === null || _a === void 0 ? void 0 : _a.id) {
            loadPopulationCaseloads((_b = pipeline.population) === null || _b === void 0 ? void 0 : _b.id);
        }
    }, [loadPopulationCaseloads, (_c = pipeline.population) === null || _c === void 0 ? void 0 : _c.id]);
    return (_jsx(_Fragment, { children: _jsx(CustomCard, { title: "Opportunity Entry", children: _jsx("div", { className: "card-body", children: _jsx(InfoItems, { items: [
                        {
                            label: "Filter",
                            value: (_d = pipeline.population) === null || _d === void 0 ? void 0 : _d.name,
                        },
                        {
                            label: "Limited To User's Caseload",
                            value: ((_e = pipeline.population) === null || _e === void 0 ? void 0 : _e.adHoc) ? (_jsx(ServiceResult, { loader: Loaders.default(), state: populationCaseloads, children: (personList) => (_jsx(_Fragment, { children: ListService.displayWithCommasAndAnd(personList.map((person) => person.fullName)) })) })) : null,
                        },
                        {
                            label: "Filter Owner",
                            value: pipeline.populationAddedBy && (_jsx(LinkToPerson, { affiliationId: (_f = pipeline.populationAddedBy) === null || _f === void 0 ? void 0 : _f.affiliationId, children: pipeline.populationAddedBy.fullName })),
                        },
                        {
                            label: "Opportunity Source",
                            value: (_g = pipeline.opportunitySource) === null || _g === void 0 ? void 0 : _g.name,
                        },
                        {
                            label: "Automated",
                            value: (_jsx(BooleanDisplay, { val: pipeline.automatedSchedule != null })),
                        },
                        {
                            label: "Schedule Running",
                            value: (_jsx(BooleanDisplay, { val: ((_h = pipeline.automatedSchedule) === null || _h === void 0 ? void 0 : _h.nextExecutionDate) != null })),
                        },
                        {
                            label: "Schedule Start",
                            value: pipeline.automatedSchedule &&
                                DateService.displayLongWithTime((_j = pipeline.automatedSchedule) === null || _j === void 0 ? void 0 : _j.startDate),
                        },
                        {
                            label: "Last Automated Refresh",
                            value: pipeline.automatedSchedule &&
                                DateService.displayLongWithTime((_k = pipeline.automatedSchedule) === null || _k === void 0 ? void 0 : _k.lastExecutionDate),
                        },
                        {
                            label: "Next Automated Refresh",
                            value: pipeline.automatedSchedule &&
                                DateService.displayLongWithTime((_l = pipeline.automatedSchedule) === null || _l === void 0 ? void 0 : _l.nextExecutionDate),
                        },
                        {
                            label: "Last Refresh",
                            value: pipeline.population != null &&
                                pipeline.pipelineStatus.id ===
                                    PipelineStatusDomainService.ActiveId ? (_jsxs("div", { className: "d-flex align-items-center", children: [_jsx("span", { title: wasLastManuallyRefreshed
                                            ? "This pipeline was last refreshed manually"
                                            : undefined, className: classNames({
                                            "dotted-underline": wasLastManuallyRefreshed,
                                        }), children: maxRefreshDate
                                            ? DateService.displayLongWithTime(maxRefreshDate)
                                            : "Never Refreshed" }), _jsx(WidgetRefreshButton, { isLoading: isLoading, onRefresh: () => refreshPopulation(), className: "py-0", title: "Refresh now", dontAddMargin: true, keepPadding: true })] })) : null,
                        },
                    ] }) }) }) }));
};
const PipelineDetailInfo = ({ pipeline, setPipeline, }) => {
    var _a, _b, _c, _d, _e, _f;
    const [pipelinePopulationRefreshState, refreshPipelinePopulation] = useService(PipelineService.refreshPipelinePopulation);
    const [confirmation, confirmModals] = useConfirmation();
    const [showError, errorModals] = useErrorPopup();
    return (_jsxs(_Fragment, { children: [_jsx(CustomCard, { title: "Info", className: "mb-3", children: _jsx("div", { className: "card-body", children: _jsx(InfoItems, { items: [
                            {
                                label: "Started By",
                                value: (_a = pipeline.startedBy) === null || _a === void 0 ? void 0 : _a.fullName,
                            },
                            {
                                label: "Person Type",
                                value: (_b = pipeline.personType) === null || _b === void 0 ? void 0 : _b.name,
                            },
                            {
                                label: "Created Date",
                                value: DateService.displayWithTime(pipeline.createdDate),
                            },
                            {
                                label: "Created By",
                                value: (_jsx(LinkToPerson, { affiliationId: pipeline.createdBy.affiliationId, children: pipeline.createdBy.fullName })),
                            },
                            {
                                label: "Roles That Can View",
                                value: (_d = (_c = pipeline.rolesThatCanView) === null || _c === void 0 ? void 0 : _c.map((role) => role.name)) === null || _d === void 0 ? void 0 : _d.join(", "),
                            },
                            {
                                label: "Roles That Can Edit",
                                value: (_f = (_e = pipeline.rolesThatCanManageOpportunities) === null || _e === void 0 ? void 0 : _e.map((role) => role.name)) === null || _f === void 0 ? void 0 : _f.join(", "),
                            },
                        ] }) }) }), _jsx(FilterAutomatedScheduleView, { pipeline: pipeline, refreshPopulation: () => {
                    confirmation(_jsxs("div", { children: [_jsx(AlertInfo, { message: "Filters based on a caseload will run with the caseload of the\n              filter creator." }), "Are you sure you want to refresh opportunities from this filter?"] })).then((confirmed) => {
                        if (confirmed) {
                            refreshPipelinePopulation(pipeline.id)
                                .then(setPipeline)
                                .catch((err) => showError("There was an error adding opportunities from this filter", typeof err === "string" ? err : null));
                        }
                    });
                }, isLoading: pipelinePopulationRefreshState.isLoading }), errorModals, confirmModals] }));
};
const PipelineDetailContent = ({ pipeline, setPipeline, refreshPipeline, }) => {
    const [cardView, setCardView] = useState(true);
    const [opportunitySearch, setOpportunitySearch] = useState({ pipelineIds: [pipeline.id] });
    const { getCheckbox, checkedItems } = useCheckboxes({
        externallyCheckedItems: [],
        equalsFunc: (a, b) => a.id === b.id,
    });
    const [tableViewLastUpdatedDate, setTableViewLastUpdatedDate] = React.useState(new Date());
    const refresh = () => {
        setTableViewLastUpdatedDate(new Date());
    };
    const [activatePipelineState, activatePipeline] = useService(PipelineService.activatePipeline);
    let navButtons = [
        _jsx(Link, { to: getPipelinesListPath(), children: _jsx(SecondaryNavButton, { icon: "chevron-left", label: "Back", title: "Back to pipelines list" }) }, "back"),
    ];
    const canManagePipelines = useHasPermission("CAN_MANAGE_PIPELINES");
    const [showError, errorModals] = useErrorPopup();
    const [confirmation, confirmModals] = useConfirmation();
    if (canManagePipelines) {
        navButtons.push(_jsx("a", { href: getPipelineEditRoute(pipeline.id), target: "_blank", rel: "noreferrer", children: _jsx(SecondaryNavButton, { icon: "pencil", label: "Edit", title: "Edit this pipeline" }) }));
    }
    if (pipeline.pipelineStatus.id === PipelineStatusDomainService.InactiveId) {
        navButtons = navButtons.concat([
            _jsx(SecondaryNavButton, { icon: "play", label: "Activate", title: "Activate this pipeline.", isLoading: activatePipelineState.isLoading, onClick: () => {
                    confirmation("Are you sure you want to activate this pipeline?").then((confirmed) => {
                        if (confirmed) {
                            activatePipeline(pipeline.id)
                                .catch((err) => showError("There was an error activating this pipeline", typeof err === "string" ? err : null))
                                .then(() => {
                                refreshPipeline();
                            });
                        }
                    });
                } }, "activate"),
        ]);
    }
    else {
        navButtons = navButtons.concat([]);
    }
    const isArchived = pipeline.pipelineStatus.id === PipelineStatusDomainService.ArchivedId;
    return (_jsxs(SecondaryNavLayout, { nav: _jsx("div", { className: "d-flex", children: navButtons }), children: [errorModals, confirmModals, _jsxs(ContentLayout, { className: "fullMinHeightMinusSecondaryNav pt-3 pb-5", children: [_jsxs("div", { className: "d-flex justify-content-between align-items-center w-100", children: [_jsx(PageTitle, { className: "mb-3", children: pipeline.name }), _jsx("div", { className: "h5", children: _jsx(PipelineStatusBadge, { pipelineStatus: pipeline.pipelineStatus }) })] }), _jsx(TabsLayout, { enableRouting: "pipelineDetailTab", tabs: pipeline.pipelineStatus.id ===
                            PipelineStatusDomainService.InactiveId
                            ? [
                                {
                                    tab: "Info",
                                    content: (_jsx(PipelineDetailInfo, { pipeline: pipeline, setPipeline: setPipeline })),
                                    id: "Info",
                                },
                            ]
                            : [
                                {
                                    tab: "Info",
                                    content: (_jsx(PipelineDetailInfo, { pipeline: pipeline, setPipeline: setPipeline })),
                                    id: "Info",
                                },
                                {
                                    tab: "Pipeline",
                                    content: (_jsxs("div", { className: "d-flex flex-column", children: [_jsxs("div", { className: "d-flex flex-column align-items-start mb-1", children: [_jsx("div", { className: "flex-grow-1 mb-2", children: _jsxs(InlineFormFormat, { saveButtonContents: "Search", handleSubmit: (formState) => __awaiter(void 0, void 0, void 0, function* () {
                                                                var _a, _b, _c, _d, _e;
                                                                setOpportunitySearch({
                                                                    stageIds: (_a = formState === null || formState === void 0 ? void 0 : formState.stages) === null || _a === void 0 ? void 0 : _a.map((stage) => stage.id),
                                                                    query: formState === null || formState === void 0 ? void 0 : formState.query,
                                                                    createdDateFrom: (_b = formState === null || formState === void 0 ? void 0 : formState.createdDateFrom) === null || _b === void 0 ? void 0 : _b.toDate(),
                                                                    createdDateTo: (_c = formState === null || formState === void 0 ? void 0 : formState.createdDateTo) === null || _c === void 0 ? void 0 : _c.toDate(),
                                                                    assignedPersonIds: (_d = formState === null || formState === void 0 ? void 0 : formState.assignees) === null || _d === void 0 ? void 0 : _d.map((p) => p.personId),
                                                                    opportunitySourceIds: (_e = formState === null || formState === void 0 ? void 0 : formState.opportunitySources) === null || _e === void 0 ? void 0 : _e.map((os) => os.id),
                                                                    pipelineIds: [pipeline.id],
                                                                });
                                                            }), children: [_jsx(TextField, { name: "query", label: "Name" }), _jsx(SearchField, { name: "stages", label: "Stage", as: (provided) => (_jsx(StageMultiSearch, Object.assign({ lookupModal: { isInModal: true }, pipelineIds: [pipeline.id] }, provided))) }), _jsx(SearchField, { label: "Opportunity Source", name: "opportunitySources", as: (provided) => (_jsx(OpportunitySourceMultiSearch, Object.assign({ lookupModal: { isInModal: true }, 
                                                                        // @ts-expect-error - Renan: Looks like this code is just wrong, can't fix that without changing logic'.
                                                                        pipelineIds: [pipeline.id] }, provided))) }), _jsx(DateRangeField, { nameStart: "createdDateFrom", nameEnd: "createdDateTo", placeHolderStart: "Entry Date From", placeHolderEnd: "Entry Date To", size: "extra-wide" }), _jsx(SearchField, { name: "assignees", label: "Assignee", as: (provided) => (_jsx(OpportunityAssigneeMultiSearch, Object.assign({}, provided, { lookupModal: { pipelineId: pipeline.id }, minNumSearchCharacters: 3, pipelineId: pipeline.id, noOptionsMessage: ({ inputValue }) => {
                                                                            if ((inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) < 3) {
                                                                                return "Please type at least 3 characters";
                                                                            }
                                                                            return "No Options";
                                                                        } }))) })] }) }), _jsxs("div", { className: "d-flex w-100 my-2 align-items-center", children: [_jsx(ToggleButton, { on: !cardView, offLabel: "Switch to List View", onLabel: "Switch to Card View", onClick: () => {
                                                                    setCardView(!cardView);
                                                                } }), !cardView && checkedItems.length ? (_jsx(PersonTypeContextProvider, { internalName: pipeline.personType.internalName, children: _jsx(PipelineDetailListMenu, { className: "mx-2", onCloseModal: () => refresh(), pipeline: pipeline, opportunities: checkedItems }) })) : (_jsx(_Fragment, {}))] })] }), _jsx(_Fragment, { children: cardView ? (_jsx(_Fragment, { children: _jsx(Provider, { children: _jsx(PipelineCardView, { pipeline: pipeline, opportunitySearch: opportunitySearch, className: "flex-grow-1 w-100", isArchived: isArchived }) }) })) : (_jsx(PipelineTableView, { pipeline: pipeline, opportunitySearch: opportunitySearch, getCheckbox: getCheckbox, refreshWatermark: tableViewLastUpdatedDate })) })] })),
                                    id: "Pipeline",
                                },
                                {
                                    tab: "Analytics",
                                    content: _jsx(PipelineDetailAnalysis, { pipeline: pipeline }),
                                    id: "Analytics",
                                },
                            ], tabStyle: "underline", children: ({ tabs, content }) => (_jsxs(_Fragment, { children: [tabs, _jsx("div", { className: "mt-3", children: content })] })) })] })] }));
};
const PipelineDetail = () => {
    const { pipelineId } = useParams();
    const [pipelineState, getPipeline, { edit: setPipeline }] = useService(PipelineService.get);
    const refreshPipeline = React.useCallback(() => {
        if (pipelineId) {
            getPipeline(+pipelineId);
        }
    }, [getPipeline, pipelineId]);
    React.useEffect(() => {
        refreshPipeline();
    }, [refreshPipeline]);
    return pipelineState.data ? (_jsx(PipelineDetailContent, { pipeline: pipelineState.data, refreshPipeline: refreshPipeline, setPipeline: setPipeline })) : (_jsx(ContentLayout, { className: "fullHeightMinusPrimaryNav", children: _jsx(ServiceResult, { state: pipelineState }) }));
};
export default PipelineDetail;
